import {
  Box,
  Grid,
  Slider,
  Stack, TextField,
  Typography,
} from '@mui/material';
import { useEffect, useMemo, useState } from 'react';

interface ImageBorderRadiusSliderProps {
  value: number;
  handleChange: (zoom: string) => void;
}

const ImageBorderRadiusSlider = ({ value, handleChange }: ImageBorderRadiusSliderProps) => {
  const [borderRadius, setBorderRadius] = useState<number>(value);
  const [inputValue, setInputValue] = useState<number>(value);
  const handleValueToChange = (value: number) => {
    handleChange(value.toString());
    setBorderRadius(value);
  };

  const checkValueRange = (value: number) => {
    if (value >= 300) {
      setInputValue(300);
    } else if (value >= 0) {
      setInputValue(value);
    } else {
      setInputValue(0);
    }
    setBorderRadius(value);
  };

  useEffect(() => {
    checkValueRange(value);
  }, [value]);

  const handleInputChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    const newValue = Number(event.target.value);
    setInputValue(newValue);
    if (newValue >= 0 && newValue <= 300) {
      handleValueToChange(newValue);
    }
  };

  const scaleSlider = useMemo(() => (
    <Slider
      min={0}
      max={300}
      step={1}
      aria-label="Zoom"
      value={borderRadius}
      sx={{ mx: 2 }}
      onChange={(event, value) => {
        handleChange(value.toString());
      }}
    />
  ), [borderRadius]);

  return (
    <Grid item sx={{ width: '100%' }}>
      <Typography className="col-form-label mb-1 text-sm" sx={{ fontWeight: '700' }}>
        Corner Radius
      </Typography>
      <Stack spacing={2} direction="row" sx={{ mb: 1 }} alignItems="center">
        Small
        {scaleSlider}
        Large
      </Stack>
      <Box className="d-flex justify-content-end align-items-center mt-1">
        <TextField
          size="small"
          inputProps={{
            inputMode: 'numeric',
            pattern: '[0-9]*',
            min: 0,
            max: 300,
            step: 1,
            style: { textAlign: 'right' },
          }}
          sx={{ width: 90 }}
          value={inputValue}
          type="number"
          onChange={handleInputChange}
          onBlur={() => handleValueToChange(inputValue)}
        />
        <Typography variant="body1" className="ms-1 text-sm">px</Typography>
      </Box>
    </Grid>
  );
};

export default ImageBorderRadiusSlider;
